import React from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from "react-router-dom";
import ErrorPage from "../components/ErrorPage/ErrorPage";
import { PanelLayout } from "../components/layout/PanelLayout";
import { LoginLayout } from "../components/layout/LoginLayout";
import { useAuth } from "../hooks/useAuth";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/DashboardPages/Dashboard/Dashboard";
import UserManagement from "../pages/DashboardPages/UserManagement/UserManagement";
import PendingPlatesClaims from "../pages/DashboardPages/PendingPlatesClaims/PendingPlatesClaims";
import ApprovedPlates from "../pages/DashboardPages/ApprovedPlates/ApprovedPlates";
import ReportedPlates from "../pages/DashboardPages/ReportedPlates/ReportedPlates";
import PlatesClaimsReview from "../pages/DashboardPages/PlatesClaimsReview/PlatesClaimsReview";
import PlateDetails from "../pages/DashboardPages/PlateDetails/PlateDetails";
import ReportedPlateClaim from "../pages/DashboardPages/ReportedPlateClaim/ReportedPlateClaim";
import PlatesManagement from "../pages/DashboardPages/PlatesManagement/PlatesManagement";
import PlateManagementView from "../pages/DashboardPages/PlateManagementView/PlateManagementView";
import UserProfile from "../pages/DashboardPages/UserProfile/UserProfile";
import BusinessProfile from "../pages/DashboardPages/BusinessProfile/BusinessProfile";
import AccountSettings from "../pages/DashboardPages/AccountSettings/AccountSettings";

// Private Route Component that uses auth hook
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Public Route Component - redirects to dashboard if already authenticated
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default function index() {
  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginLayout />
            </PublicRoute>
          }
        >
          <Route index element={<Login />} />
        </Route>
        <Route
          path="/"
          errorElement={<ErrorPage />}
          element={
            <PrivateRoute>
              <PanelLayout />
            </PrivateRoute>
          }
        >
          <Route path="/login" element={<Login />} />
          <Route index element={<Dashboard />} />
          <Route path="/plates-management" element={<PlatesManagement />} />
          <Route
            path="/plates-management/view"
            element={<PlateManagementView />}
          />
          <Route
            path="/plates-management/pending-plates-claims"
            element={<PendingPlatesClaims />}
          />
          <Route
            path="/plates-management/pending-plates-claims/plate-claim-review"
            element={<PlatesClaimsReview />}
          />
          <Route
            path="/plates-management/approved-plates"
            element={<ApprovedPlates />}
          />
          <Route
            path="/plates-management/approved-plates/plate-details"
            element={<PlateDetails />}
          />
          <Route
            path="/plates-management/reported-plates"
            element={<ReportedPlates />}
          />
          <Route
            path="/plates-management/reported-plates/plate-claim-review"
            element={<ReportedPlateClaim />}
          />
          <Route path="/user-management" element={<UserManagement />} />
          <Route
            path="/user-management/user-profile"
            element={<UserProfile />}
          />
          <Route
            path="/user-management/business-profile"
            element={<BusinessProfile />}
          />
          <Route path="/account-settings" element={<AccountSettings />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}
